<template>
  <div>
    <div class="row sqs-row">
      <div class="col sqs-col-3 span-3">
        <sidebar-nav></sidebar-nav>
      </div>
      <div class="col sqs-col-9 span-9">
        <div class="sqs-block code-block sqs-block-code">
          <div class="sqs-block-content">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarNav from '@/components/SidebarNav'
import { mapGetters } from 'vuex'

// https://gist.github.com/jed/982883
const uuid = function b (a) {
  return a ? (a^Math.random()*16>>a/4) // eslint-disable-line
    .toString(16) : // eslint-disable-line
    ([1e7]+-1e3+ -4e3+ -8e3+ -1e11).replace(/[018]/g,b); // eslint-disable-line
}

export default {
  name: 'App',
  components: {
    SidebarNav
  },
  created () {
    this.$store.dispatch('setSessionId', uuid())
  },
  computed: {
    ...mapGetters({ user: 'auth/user' })
  },
  watch: {
    user () {
      if (!this.user.updated) {
        this.$router.push('/update-info')
      }
    }
  }
}
</script>

<style scoped>
</style>
